/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductTag
 */
export interface ProductTag {
    /**
     * 
     * @type {number}
     * @memberof ProductTag
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTag
     */
    tagId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductTag
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductTag
     */
    updatedAt?: Date;
}

export function ProductTagFromJSON(json: any): ProductTag {
    return ProductTagFromJSONTyped(json, false);
}

export function ProductTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'tagId': !exists(json, 'tagId') ? undefined : json['tagId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ProductTagToJSON(value?: ProductTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'tagId': value.tagId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


